import React from 'react';
import { connect } from 'react-redux';
import { getSearchResults } from './actions';
import { searchOptsFromQueryParams, searchPageId } from './helpers';
import HeadTags from './head';
import Filters from '../filter';
import { pathForQueryParams } from '../filter/helpers';
import SearchResultsHeader from './header';
import CategoryProductsList from '../category/productsList';
import { MainPlusAsideContainer } from 'scy/layouts';
import CategoryEmptyList from '../category/emptyList';
import { Body } from 'scy/text';
import { textCenter } from 'scy/utils.mod.scss';
import margin from 'scy/margin.mod.scss';
import AsyncLeadCaptureModal from 'components/leadCaptureModal/async';
import { isEqual as sameAddress } from 'shared/models/address';

function getSearchQuery(params) {
  if (!params || !params.searchQuery) return '';
  return decodeURIComponent(params.searchQuery);
}

class SearchResultsPage extends React.Component {
  componentDidMount() {
    const searchQuery = getSearchQuery(this.props.match.params);
    const queryParams = this.props.location.search;
    const pageId = searchPageId(searchQuery, queryParams);
    if (pageId !== this.props.pageId) {
      this.props.getSearchResults(searchQuery, queryParams);
    }
  }

  componentDidUpdate(prevProps) {
    const addressHasChanged = !sameAddress(
      prevProps.address,
      this.props.address
    );
    if (addressHasChanged || this.props.location !== prevProps.location) {
      const searchQuery = getSearchQuery(this.props.match.params);
      this.props.getSearchResults(searchQuery, this.props.location.search);
    }
  }

  render() {
    const {
      loadingProducts,
      loadingCount,
      products,
      count,
      facets,
      match,
      location
    } = this.props;

    const searchQuery = getSearchQuery(match.params);

    if (!searchQuery) return null;

    const { hitsPerPage, page } = searchOptsFromQueryParams(location.search);
    const offset = hitsPerPage * page;

    return (
      <div className="banner-padding">
        <HeadTags query={searchQuery} />

        <MainPlusAsideContainer
          className={margin.top_md}
          renderAside={() => <Filters facets={facets} location={location} />}
          renderMain={() =>
            !loadingProducts && !products.length ? (
              <>
                <SearchResultsHeader query={searchQuery} count={count} />
                <CategoryEmptyList>
                  <Body className={textCenter} marginClass={margin.xl}>
                    Sorry, your search for {searchQuery} did not return any
                    results.
                  </Body>
                </CategoryEmptyList>
              </>
            ) : (
              <>
                <SearchResultsHeader
                  query={searchQuery}
                  count={count}
                  loading={loadingCount}
                />
                <CategoryProductsList
                  loading={loadingProducts}
                  products={products}
                  itemCount={count}
                  offset={offset}
                  pageSize={hitsPerPage}
                  pathForOffset={offset =>
                    pathForQueryParams(location, { skip: offset })
                  }
                />
              </>
            )
          }
        />

        <AsyncLeadCaptureModal />
      </div>
    );
  }
}

export default connect(
  state => ({
    address: state.address,
    pageId: state.searchResults.pageId,
    loadingProducts: state.searchResults.loadingProducts,
    loadingCount: state.searchResults.loadingCount,
    products: state.searchResults.products,
    count: state.searchResults.count,
    facets: state.searchResults.facets,
    pageSize: state.searchResults.pageSize,
    skip: state.searchResults.skip
  }),
  { getSearchResults }
)(SearchResultsPage);
